module.exports = __webpack_public_path__ + "img/20240918141619987gif.07728921.jpg";